module.exports = __webpack_public_path__ + "static/media/19ESCAP42.a08a3141.jpg";